module.exports = __webpack_public_path__ + "static/media/uwp_logo.c800dc51.svg";